import { authDomain } from '@auth';
import { useMutation } from '@tanstack/react-query';

export const useSendRestoreLink = () => {
  return useMutation((payload: authDomain.SendRestoreLinkDto) => {
    return authDomain.authService.sendRestoreLink(payload);
  });
};
